module.exports = "<body>\n\n  <ng-progress></ng-progress>\n  \n  <app-header></app-header>\n  \n  <router-outlet></router-outlet>\n\n</body>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main